import { Grid, Skeleton } from '@mui/material';
import React from 'react';
import { formatCurrency } from '../../utils/formatCurrency';
import ReportCard from './Components/ReportCard';

const Reports = ({ data, loading }) => {
  if (loading) {
    return (
      <Grid container spacing={1} sx={{ marginTop: 2 }}>
        <Grid item xl={2.5} lg={2.5} sm={6} xs={12}>
          <Skeleton variant="rectangular" height={130} />
        </Grid>
        <Grid item xl={2} lg={2} sm={6} xs={12}>
          <Skeleton variant="rectangular" height={130} />
        </Grid>
        <Grid item xl={2} lg={2} sm={6} xs={12}>
          <Skeleton variant="rectangular" height={130} />
        </Grid>
        <Grid item xl={2} lg={2} sm={6} xs={12}>
          <Skeleton variant="rectangular" height={130} />
        </Grid>
        <Grid item xl={2} lg={2} sm={6} xs={12}>
          <Skeleton variant="rectangular" height={130} />
        </Grid>
        <Grid item xl={1.5} lg={1.5} sm={6} xs={12}>
          <Skeleton variant="rectangular" height={130} />
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid container spacing={1} sx={{ marginTop: 2 }}>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <ReportCard
          title="Category HIPO"
          multiValue
          value={[data.reportNumberLkpHipo, data.reportNumberLkpNonHipo]}
          footer={['HIPO', 'Non-HIPO']}
        />
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <ReportCard
          title="Total"
          multiValue
          value={[data.reportNumberIncident, data.reportNumberInvestigation]}
          footer={['Incidents', 'Investigations']}
        />
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <ReportCard
          title="Recordable Incident Cases"
          value={data.recordableIncidentCases}
        />
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <ReportCard
          title="Process Safety Incident Cases"
          value={data.processSafetyIncidentCases}
        />
      </Grid>
      <Grid item xl={4} lg={4} sm={6} xs={12}>
        <ReportCard
          title={`Financial Impact (${data.financialImpactSatuan})`}
          value={formatCurrency(data.financialImpact)}
          longValue={true}
        />
      </Grid>
      <Grid item xl={4} lg={4} sm={6} xs={12}>
        <ReportCard
          title={`Gas Release (${data.gasReleaseSatuan})`}
          value={formatCurrency(data.gasRelease)}
          longValue={true}
        />
      </Grid>
      <Grid item xl={4} lg={4} sm={6} xs={12}>
        <ReportCard
          title={`Oil Spill (${data.oilSpillSatuan})`}
          value={formatCurrency(data.oilSpill)}
          longValue={true}
        />
      </Grid>
    </Grid>
  );
};

export default Reports;
